import dateselect from './DateSelect.vue'
const DateSelect = {
	install: function(Vue) {
		Vue.component('DateSelect', dateselect)
	}
}
export default DateSelect
